// React Router v5 → v6 compatibility shim
import { useNavigate, useLocation } from 'react-router-dom';

/**
 * Compatibility shim for useHistory from React Router v5
 * Use useNavigate from react-router-dom v6 instead
 */
export function useHistory() {
  const navigate = useNavigate();
  const location = useLocation();
  
  return {
    push: (path: string, state?: any) => navigate(path, { state }),
    replace: (path: string, state?: any) => navigate(path, { replace: true, state }),
    goBack: () => navigate(-1),
    goForward: () => navigate(1),
    location,
  };
}

